import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { TranslateService, VersionCheckService } from "__services";
import { Subject } from 'rxjs';
import { GoogleMapsLoaderService } from './core/services/google-maps-loader.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  public destroy$: Subject<any> = new Subject();

  constructor(
    public loader: LoadingBarService,
    private versionCheckService: VersionCheckService,
    private translateService: TranslateService,
    private mapsLoader: GoogleMapsLoaderService
  ) {
  }

  async ngOnInit(): Promise<void> {
    await this.mapsLoader.load();

    await this.translateService.init();

    if (location.hostname !== 'localhost') {
      this.versionCheckService.initVersionCheck(`${window.location.origin}/version.json`, (1000 * 60));
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
